<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Cobranzas
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            <span
              class="bg-green-100 text-green-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3"
              >GET</span
            >
            <span class="text-xs xl:text-base">
              https://sb-wee.ar/v1/reporte/cobranzas?Date=03-01-2023</span
            >
          </h3>
          <p class="text-gray-600 text-sm xl:text-base mb-2">
            Retorna todas las cobranzas para el día especificado.
          </p>
        </div>

        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable
          title="Headers"
          :headers="headersCobranzas"
          :data="headersData"
          height="auto"
        />

        <!-- Body Table -->
        <DynamicTable
          title="Path parameters"
          :headers="bodyHeaders"
          :data="bodyParameters"
          height="auto"
        />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable
          title="Atributos del objeto de la respuesta."
          :headers="responseHeaders"
          :data="responseData"
          height="auto"
        />

        <DynamicTable
          title="Atributos del objeto result."
          :headers="responseHeadersDataResult"
          :data="responseResultData"
          height="150px"
        />

        <DynamicTable
          title="Atributos del objeto data."
          :headers="responseHeadersObjet"
          :data="responseObjectData"
          height="150px"
        />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->

        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            Headers
          </h4>
          <span class="text-black">
            <p>
              <code class="text-black">Content-Type: application/json</code>
            </p>
            <p>
              <code class="text-black"
                >Authorization: Bearer {{ apikeyExample }}</code
              >
            </p>
          </span>
        </div>

        <!-- Response Example -->
        <CodeBlock
          title="Example Response"
          :code="responseExample"
          language="json"
          status="info"
          :is-large="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "Cobranzas",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersCobranzas: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "pattern", label: "PATTERN" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "Sí",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },
        {
          atributo: "Authorization",
          tipo: "String",
          requerido: "Sí",
          pattern: "Bearer",
          descripcion: "aa7943e1-a60c-99e7-8812-xxxxxxxxxxxx",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyHeaders: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "Date",
          tipo: "String",
          requerido: "Sí",
          descripcion:
            "Fecha de cobranzas. Solo se puede pedir este reporte para una fecha anterior al día actual. Formato DD-MM-YYYY",
        },
      ],

      // Response

      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de la respuesta.",
        },
        {
          atributo: "result",
          tipo: "Object",
          descripcion: "Objeto con la información de la respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],

      responseHeadersDataResult: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseResultData: [
        {
          atributo: "account_id",
          tipo: "String",
          descripcion: "ID de la cuenta propietaria del Reporte.",
        },
        {
          atributo: "report_date",
          tipo: "String",
          descripcion: "Fecha en la que se informaron los cobros..",
        },
        {
          atributo: "total_collected",
          tipo: "Float",
          descripcion:
            "Importe total cobrado. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "total_gross_fee",
          tipo: "Float",
          descripcion:
            "Importe total de comisión. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "total_net_amount",
          tipo: "Float",
          descripcion:
            "Importe total por acreditar. Equivalente a Importe total cobrado menos importe total de comisión. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "data",
          tipo: "Array [Object]",
          descripcion: "Arreglo de objetos con información de cada cobro.",
        },
      ],

      responseHeadersObjet: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectData: [
        {
          atributo: "informed_date",
          tipo: "DateTime",
          descripcion: "Fecha en la que se informó el cobro.",
        },
        {
          atributo: "request_id",
          tipo: "Integer",
          descripcion: "ID de la solicitud.",
        },
        {
          atributo: "external_reference",
          tipo: "String",
          descripcion:
            "Este atributo es utilizado como referencia para identificar la solicitud y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "payer_name",
          tipo: "String",
          descripcion: "Nombre del pagador.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripción o concepto cobrado.",
        },
        {
          atributo: "payment_date",
          tipo: "DateTime",
          descripcion: "Fecha de pago.",
        },
        {
          atributo: "channel",
          tipo: "String",
          descripcion: "Nombre del medio de pago utilizado.",
        },
        {
          atributo: "amount_paid",
          tipo: "Float",
          descripcion: "Importe pagado. Formato...",
        },
        {
          atributo: "net_fee",
          tipo: "Float",
          descripcion:
            "Comisión neta. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "iva_fee",
          tipo: "Float",
          descripcion:
            "IVA de la comisión. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "net_amount",
          tipo: "Float",
          descripcion:
            "Importe Neto. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "available_at",
          tipo: "DateTime",
          descripcion:
            "Fecha y hora en la que el saldo de la transacción queda disponible.",
        },
      ],

      apikeyExample: " {{ apikey }}",

      responseExample: `{
    "message": "Solicitud cobranzas generada",
    "result": {
        "account_id": "000004",
        "report_date": "2023-01-03T00:00:00Z",
        "total_collected": 12303.23,
        "total_gross_fee": 201.98,
        "total_net_amount": 12101.25,
        "data": [
            {
                "informed_date": "2023-01-03T00:00:00Z",
                "request_id": 494,
                "external_reference": "iEXb72Whd",
                "payer_name": "VANASCO JOSÉ LUIS",
                "description": "CONEXIÓN ID 0028 - MES: ENERO",
                "payment_date": "2023-01-03T18:00:00Z",
                "channel": "VISA",
                "amount_paid": 6900,
                "net_fee": 110.4,
                "iva_fee": 23.18,
                "net_amount": 6766.42,
                "available_at": "2023-01-20 03:00:02"
            },
            {
                "informed_date": "2023-01-03T00:00:00Z",
                "request_id": 483,
                "external_reference": "tqgQSorfm",
                "payer_name": "SUÁREZ AGUSTÍN RAMÓN",
                "description": "CONEXIÓN ID 0013 - MES: ENERO",
                "payment_date": "2023-01-03T14:39:00Z",
                "channel": "VISA DÉBITO",
                "amount_paid": 503.23,
                "net_fee": 9.99,
                "iva_fee": 2.1,
                "net_amount": 491.14,
                "available_at": "2023-01-06 13:03:39"
            },
            {
                "informed_date": "2023-01-03T00:00:00Z",
                "request_id": 469,
                "external_reference": "pJkamU74X",
                "payer_name": "HERRERA CRISTINA ANABEL",
                "description": "CONEXIÓN ID 0012 - MES: ENERO",
                "payment_date": "2023-01-03T09:53:00Z",
                "channel": "VISA DÉBITO",
                "amount_paid": 4900,
                "net_fee": 46.54,
                "iva_fee": 9.77,
                "net_amount": 4843.69,
                "available_at": "2023-01-06 13:03:39"
            }
        ]
            },
            "status": true
        }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
